import {
  AlertTriangle,
  Award,
  Bookmark,
  Calendar,
  CheckCircle,
  CircleOff,
  ClipboardList,
  Clock,
  CreditCard,
  DollarSign,
  FileEdit,
  FileText,
  Flag,
  Heart,
  type LucideIcon,
  Mail,
  MessageSquare,
  Phone,
  PhoneOff,
  ShieldCheck,
  Star,
  Target,
  Trash2,
  TrendingUp,
  UserCheck,
  Users,
  XCircle,
  Zap,
} from "lucide-react";

/** Icons a pipeline stage can carry — stored by name in pipeline_stages.icon. Picker order. */
const PIPELINE_STAGE_ICONS: { name: string; icon: LucideIcon }[] = [
  { name: "ClipboardList", icon: ClipboardList },
  { name: "Calendar", icon: Calendar },
  { name: "FileEdit", icon: FileEdit },
  { name: "CheckCircle", icon: CheckCircle },
  { name: "CircleOff", icon: CircleOff },
  { name: "XCircle", icon: XCircle },
  { name: "PhoneOff", icon: PhoneOff },
  { name: "FileText", icon: FileText },
  { name: "Clock", icon: Clock },
  { name: "Star", icon: Star },
  { name: "Heart", icon: Heart },
  { name: "Zap", icon: Zap },
  { name: "Target", icon: Target },
  { name: "Flag", icon: Flag },
  { name: "Bookmark", icon: Bookmark },
  { name: "Award", icon: Award },
  { name: "TrendingUp", icon: TrendingUp },
  { name: "Users", icon: Users },
  { name: "UserCheck", icon: UserCheck },
  { name: "Phone", icon: Phone },
  { name: "Mail", icon: Mail },
  { name: "MessageSquare", icon: MessageSquare },
  { name: "DollarSign", icon: DollarSign },
  { name: "CreditCard", icon: CreditCard },
  { name: "ShieldCheck", icon: ShieldCheck },
  { name: "AlertTriangle", icon: AlertTriangle },
  { name: "Trash2", icon: Trash2 },
];

const BY_NAME: Record<string, LucideIcon> = Object.fromEntries(PIPELINE_STAGE_ICONS.map((i) => [i.name, i.icon]));

/** A stage's icon; FileText when it has none or an unknown one. */
const pipelineStageIcon = (name?: string | null): LucideIcon => (name ? BY_NAME[name] : undefined) ?? FileText;

export { PIPELINE_STAGE_ICONS, pipelineStageIcon };
